import React from 'react';

/**
 * Individual Toast Component
 */
export const Toast = ({ toast, onClose }) => {
  const getToastIcon = (type) => {
    switch (type) {
      case 'success':
        return 'fa-check-circle text-success';
      case 'info':
        return 'fa-info-circle text-info';
      case 'warning':
        return 'fa-exclamation-triangle text-warning';
      case 'danger':
        return 'fa-times-circle text-danger';
      default:
        return 'fa-info-circle text-info';
    }
  };

  const getToastTitle = (type) => {
    switch (type) {
      case 'success':
        return 'Success';
      case 'info':
        return 'Information';
      case 'warning':
        return 'Warning';
      case 'danger':
        return 'Error';
      default:
        return 'Notification';
    }
  };

  return (
    <div className="toast show" role="alert" aria-live="assertive" aria-atomic="true">
      <div className="toast-header">
        <i className={`fas ${getToastIcon(toast.type)} me-2`}></i>
        <strong className="me-auto">{getToastTitle(toast.type)}</strong>
        <small className="text-muted">now</small>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={() => onClose(toast.id)}
        ></button>
      </div>
      <div className="toast-body">
        {toast.message}
      </div>
    </div>
  );
};

export default Toast;